// extracted by mini-css-extract-plugin
export default {"cards":"AboutCards_cards__5gzqO","about_card":"AboutCards_about_card__eXvwv","about_card_shape":"AboutCards_about_card_shape__QH+xs"};